import React from "react";
import { fetchBusinessCategories } from "../../utils";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";

class Searchproduct extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      searchTerm: "",
      showCategories: false,
      categories: [],
      category: "",
      suggestedProducts: [],
    };

    this.makeProductSearch = this.makeProductSearch.bind(this);
  }

  async makeProductSearch(event) {
    event.preventDefault();

    let path = this.props.location.pathname;
    path += "?search=" + this.state.searchTerm;
    this.props.history.push(path);
  }

  async componentDidMount() {
    let categories = await fetchBusinessCategories();
    if (categories) {
      this.setState({
        categories: categories,
      });
    }
  }

  suggestProductSearches(e) {
    e.keyCode === 13
      ? document.getElementById("search-submit-btn").click()
      : document.getElementById("search-submit-btn");
  }

  render() {
    let searching = "";
    if (this.props.searching) {
      searching = "is-loading";
    }

    return (
      <form onSubmit={this.makeProductSearch}>
        <Dropdown
          onChange={(e) => {
            this.setState({ category: e.value });
          }}
          value={this.state.category}
          options={this.state.categories}
          optionLabel="name"
          optionValue="id"
          placeholder="Select a category"
          className="mb-2 center-block m-custom-dropdown"
        />
        <div className="search-product-wrapper d-flex align-items-center">
          <Dropdown
            onChange={(e) => {
              this.setState({ category: e.value });
            }}
            value={this.state.category}
            options={this.state.categories}
            optionLabel="name"
            optionValue="id"
            placeholder="Select a category"
            className="custom-dropdown"
          />
          <div className="p-inputgroup">
            <span className="p-inputgroup-addon">
              <i className="zmdi zmdi-search"></i>
            </span>
            <InputText
              onChange={(e) => this.setState({ searchTerm: e.target.value })}
              placeholder="Search the market"
            />
            <div className="product-suggestion d-none"></div>
          </div>
          <Button label="Search" />
        </div>
      </form>
    );
  }
}

export default Searchproduct;
